import { useEffect } from 'react'
import { useMsal } from '@azure/msal-react'
import { InteractionStatus } from '@azure/msal-browser'
import { loginRequest } from '@/services/authConfig'
import { initApiAuth, auditApi } from '@/services/api'

export function useAuth() {
  const { instance, accounts, inProgress } = useMsal()

  // Wire up the MSAL instance to the Axios interceptor once
  useEffect(() => {
    initApiAuth(instance)
  }, [instance])

  const user = accounts[0] ?? null
  const isLoading = inProgress !== InteractionStatus.None

  function login() {
    instance.loginRedirect(loginRequest)
  }

  async function logout() {
    // El redirect aborta las peticiones en vuelo, así que ESPERAMOS a registrar el
    // logout antes de redirigir, con un tope de 2s para no colgar el cierre si la
    // escritura falla o tarda. Limpiamos el flag para que el próximo acceso registre
    // un nuevo 'login'.
    sessionStorage.removeItem('airval_audit_login')
    await Promise.race([
      auditApi.log({ accion: 'logout' }),
      new Promise((resolve) => setTimeout(resolve, 2000)),
    ])
    instance.logoutRedirect({ postLogoutRedirectUri: window.location.origin })
  }

  return { user, isLoading, login, logout }
}
